<template lang="pug">
span.download-buttons
  a.download-button.elevation-4(:href="link" v-if="typeRef === 'youtube'" :style="getBackgroundColorPropertyStyle(color)" target="_blank")
    i.ap-youtube-logo
  a.download-button.elevation-4(:href="link" v-if="typeRef === 'link'" :style="getBackgroundColorPropertyStyle(color)" target="_blank")
    i.material-icons link
  a.download-button.elevation-4(:href="link" v-if="typeRef === 'download'" :style="getBackgroundColorPropertyStyle(color)" download)
    i.ap-download
</template>

<script>
import colorPropertyMixin from '@/mixins/color-property.js'
import theme from '@/theme.js'

export default {
  name: 'DownloadButton',
  mixins: [colorPropertyMixin],
  props: {
    color: {
      type: String,
      default: theme.defaultHeaderColor
    },
    baseUrl: String,
    href: String,
    type: {
      type: String,
      default: 'link'
    }
  },
  data: () => ({
    link: null,
    typeRef: null
  }),
  watch: {
    baseUrl () {
      this.mapDocuments()
    },
    link () {
      this.mapDocuments()
    },
    type () {
      this.mapDocuments()
    }
  },
  mounted () {
    this.mapDocuments()
  },
  methods: {
    mapDocuments () {
      if (this.baseUrl) this.link = `${this.baseUrl}/${this.href}`
      else this.link = this.href
      if (this.type) this.typeRef = this.type
      else if (this.link.indexOf('youtube') >= 0) this.typeRef = 'youtube'
    }
  }
}
</script>

<style scoped lang="stylus">
@import '~@/styles/variables'

$download-button-size = $f32px

.download-buttons
  a.download-button
    border-radius: 50%
    width: $download-button-size
    height: $download-button-size
    margin-bottom: $f10px
    color: white
    i
      color: white
      &.material-icons
        min-width: $download-button-size

</style>
